

/**
 * Creates a `piecemeal loader` object, for use through-out SBM Websites.
 * It breaks the initialisation steps a component needs to perform into
 * multiple steps, so we limit the amount of work a component completes per
 * frame, allowing for a 'smoother' looking website.
 */

var requestAnimationFrame = window.requestAnimationFrame;

if (! requestAnimationFrame) {
  // create a fullback implementation for browsers that don't have request
  // animation frame.
  requestAnimationFrame = function(callback) {
    window.setTimeout(callback, 10);
  };
}

var PiecemealLoader = function(steps) {
  this.steps = steps;

  this.executeStep = this.executeStep.bind(this);
}
PiecemealLoader.prototype.initialise = function() {
  requestAnimationFrame(this.executeStep);
};
PiecemealLoader.prototype.executeStep = function() {
  if (this.steps.length) {
    var nextStep = this.steps.shift();

    nextStep();

    if (this.steps.length > 0) {
      requestAnimationFrame(this.executeStep);
    }
  }
};

export default PiecemealLoader;

